module.exports = "img/element-icons/room/default_cal.6bea887.svg";